export default __webpack_public_path__ + "4f07d14f958e49021ecdb1882c6a0cc9.png";